export default {
  BOX: "box",
};
